import { Typography } from "best-common-react-3";
import { format } from "date-fns";
import React from "react";
import { GameDataDTO } from "../../../../types/DailyAssignmentTypes";

export const getGameInfo = (game: GameDataDTO, selected = false, color?: string) => {
  let gameDateTime: Date;
  let formattedDateTime: string;

  if (game?.displayTime?.includes("TBD")) {
    gameDateTime = new Date(`${game.gameDt}`);
    formattedDateTime = format(gameDateTime, "M/dd • ").toLowerCase() + "TBD";
  } else {
    gameDateTime = new Date(`${game.gameDt} ${game.gameTime}`);
    formattedDateTime = format(gameDateTime, "M/dd • h:mm a").toLowerCase();
  }
  return (
    <div className="flex min-w-0 flex-col leading-tight">
      <Typography
        variant="labelMedium"
        elementStyles={{
          color: color ?? (selected ? "var(--color-on-secondary)" : "var(--color-secondary)"),
          weight: "bold",
        }}
      >
        {game?.away?.abbreviation || "TBD"} @ {game?.home?.abbreviation || "TBD"} • {game?.gamePk}
      </Typography>
      <Typography
        variant="labelMedium"
        elementStyles={{
          color: color ?? (selected ? "var(--color-on-secondary)" : "var(--color-secondary)"),
          weight: "bold",
        }}
      >
        {game.status === "PPD" ? "PPD" : formattedDateTime}
      </Typography>
    </div>
  );
};
